import ja from "./ja.js";
import en from "./en.js";
import { getDevice, setDevice } from "../meta/device.js";

// 画面に出す文の言語の切り替え(2026-10-31 オーナー要望「ブラウザの設定で自動的に切り替え。オプションでも切り替え可能に」)。
// 文はすべて ja.js(日本語)・en.js(英語)の表に、同じキーで書く。コードでは t("キー") で取り出す。
// - 言語の決め方: この端末で選んだもの(src/meta/device.js の lang)> ブラウザの言語(日本語なら ja、それ以外は en)
// - 英語の表に無いキーは日本語を出す(書き忘れても画面が空にならない。tests/i18n.test.js で抜けを調べる)
// - index.html の決まった文は data-i18n="キー"(aria-label は data-i18n-aria)を付けておくと applyDom() が入れ替える
// 試合の計算(src/sim/)からは使わないこと(言語で試合が変わらないように)。

export const LANGS = ["ja", "en"];
export const TABLES = { ja, en };
const storage = (value) => (value === undefined ? getDevice("lang") ?? null : setDevice("lang", value));

// ブラウザの言語から決める(日本語が先に来ていれば ja、それ以外は en)
export function detectLang(languages = globalThis.navigator?.languages || [globalThis.navigator?.language].filter(Boolean)) {
  for (const l of languages) {
    const base = String(l).toLowerCase().split("-")[0];
    if (LANGS.includes(base)) return base;
  }
  return "en";
}

let choice = LANGS.includes(storage()) ? storage() : "auto"; // "auto" | "ja" | "en"
let lang = choice === "auto" ? detectLang() : choice;
const listeners = [];

export const getLang = () => lang;
export const getLangChoice = () => choice;

// "auto"(ブラウザに合わせる)・"ja"・"en"。選んだものはこの端末に覚えておく
export function setLang(next) {
  choice = LANGS.includes(next) ? next : "auto";
  storage(choice === "auto" ? null : choice);
  lang = choice === "auto" ? detectLang() : choice;
  applyDom();
  for (const fn of listeners) fn(lang);
}

// 言語が変わったときに、作り直す画面の部分を登録する
export function onLangChange(fn) {
  listeners.push(fn);
}

// キーの文を返す。{name} は params の値で置きかえる。どの表にも無ければキーをそのまま返す
export function t(key, params) {
  const s = TABLES[lang][key] ?? ja[key] ?? key;
  return params ? s.replace(/\{(\w+)\}/g, (m, k) => (k in params ? String(params[k]) : m)) : s;
}

// そのキーの文があるか(説明がある・ないを選べるもの用)
export const has = (key) => key in ja;

// index.html の data-i18n・data-i18n-aria の付いた所を、今の言語の文にする
export function applyDom(root = globalThis.document) {
  if (!root?.querySelectorAll) return;
  if (root.documentElement) root.documentElement.lang = lang;
  for (const el of root.querySelectorAll("[data-i18n]")) el.textContent = t(el.dataset.i18n);
  for (const el of root.querySelectorAll("[data-i18n-aria]")) el.setAttribute("aria-label", t(el.dataset.i18nAria));
}
